import { render, staticRenderFns } from "./certificates-table-row-menu.vue?vue&type=template&id=7d344f98"
import script from "./certificates-table-row-menu.vue?vue&type=script&lang=js"
export * from "./certificates-table-row-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports